// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Money20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Money20: FC<Money20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.25 17v-1.667a3.709 3.709 0 0 1-1.823-.958 3.99 3.99 0 0 1-1.073-1.813l1.542-.624c.111.5.392.947.844 1.343.451.396.92.594 1.406.594.541 0 .986-.139 1.333-.417.347-.277.521-.639.521-1.083 0-.417-.156-.764-.469-1.042-.312-.277-.864-.555-1.656-.833C8.792 10.111 8 9.684 7.5 9.219c-.5-.466-.75-1.066-.75-1.802 0-.695.226-1.292.677-1.792.451-.5 1.06-.826 1.823-.98V3h1.5v1.646c1 .167 1.67.548 2.01 1.146.34.597.518.91.532.937l-1.459.604a1.69 1.69 0 0 0-.666-.896 1.868 1.868 0 0 0-1.104-.354c-.487 0-.89.125-1.209.375-.32.25-.479.556-.479.917s.174.67.52.927c.348.257.994.545 1.938.865.973.32 1.68.736 2.125 1.25.445.514.667 1.166.667 1.958s-.257 1.458-.77 2c-.515.542-1.216.882-2.105 1.02V17h-1.5Z" />
        </svg>
    );
};

export default Money20;
